import { createFileRoute } from '@tanstack/react-router';
import { AdminCommunityPage } from '../../features/community';

export const Route = createFileRoute('/admin/community/')({ component: AdminCommunityPage });
